
import { Store, Order, TaxReport } from '../types';

export const taxService = {
  calculateTax: (subtotal: number, taxRate: number) => {
    return (subtotal * taxRate) / 100;
  },

  formatTaxId: (taxId: string) => {
    return taxId.toUpperCase().trim();
  },

  generateTaxSummary: (orders: Order[]): TaxReport => {
    // Basic logic to sum up tax values from orders
    const summary = orders.reduce((acc, order) => {
      if (order.status === 'CANCELLED') return acc;
      
      return {
        totalTaxableValue: acc.totalTaxableValue + (order.subtotal || 0),
        totalTaxCollected: acc.totalTaxCollected + (order.taxAmount || 0),
        totalCommissionTax: (acc.totalCommissionTax || 0) + ((order.platformCommission || 0) * 0.18), // 18% tax on commission (standard)
      };
    }, { totalTaxableValue: 0, totalTaxCollected: 0, totalCommissionTax: 0 });

    return {
      ...summary,
      period: 'Current Quarter'
    };
  }
};
